import {DocumentNode, gql} from "@apollo/client";

export const CHANGE_ERROR_PAYOUT_MUTATION: DocumentNode = gql(`
    mutation ChangeErrorPayoutOperation($operationId: Float!, $status: OperationStatus!, $tfaCode: String) {
        changeErrorPayoutOperation(operationId: $operationId, status: $status, tfaCode: $tfaCode) {
            message
        }
    }
`);
